import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-trade-moneda',
    templateUrl: './modal-trade-moneda.component.html',
    styleUrls: ['./modal-trade-moneda.component.scss'],
    standalone: false
})
export class ModalTradeMonedaComponent implements OnInit {
  monedas: any;
  btnStatus: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ModalTradeMonedaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    //This is intentional
  }

  onNoClick(): void {
    const res = {
      status: false,
      moneda: null
    }
    this.dialogRef.close(res);
  }

  onSubmit(): void {
    const res = {
      status: true,
      moneda: this.monedas
    }
    this.dialogRef.close(res);
  }

  addValue(data) {
    console.log('data', data);
    this.btnStatus = (data === "");
  }

}
